import { NavigationPage } from 'app-components'
import { LoadingContainer } from '@/components/Animations/FadeContainer/FadeContainer'
import { useNavigation } from '@/app/hooks'
import { useUrlWithUtilityBasePath } from '@/app/hooks/useUtilityBasePath'
import { ButtonContainer } from '@/app/pages/ava/BrandedPage'
import { Button } from '@/components'
import React from 'react'
import { MultiProgramOnboardingFlowProvider } from '@/app/context/MultiProgram/MultiProgramFlowContexts'
import useUtilityPrograms from '@/app/hooks/useUtilityPrograms'
import ProgramCard from '@/components/ProgramCard/ProgramCard'

function generateTitles(programsAvailable: number) {
  if (programsAvailable === 0) {
    return {
      title: 'We did not find any programs in your area.',
      subtitle:
        'Press the continue button to proceed with onboarding your account.',
    }
  }

  return {
    title: `We found ${programsAvailable} program(s) in your area, would you like to apply?`,
    subtitle: 'Enroll in programs to start saving on your energy bill.',
  }
}

const EXIT_URL = '/onboarding?questionsToSkip=homeAddress'

export default function OnboardingProgramFinderPage() {
  const { isLoading, availablePrograms } = useUtilityPrograms({
    onlyMultiPrograms: true,
  })
  const { url: onboardingUrl } = useUrlWithUtilityBasePath(EXIT_URL)
  const navigate = useNavigation()

  const onClosePage = () => navigate.push(onboardingUrl ?? EXIT_URL)

  const title = isLoading
    ? 'Searching for programs near you...'
    : generateTitles(availablePrograms?.length).title
  const subtitle = isLoading
    ? 'Please wait'
    : generateTitles(availablePrograms?.length).subtitle

  const onButtonClicked = () => {
    navigate.push(onboardingUrl ?? EXIT_URL)
  }

  const loadedContent = (
    <div className="flex flex-col gap-4">
      {availablePrograms?.map((program) => (
        <div className="card-shadow w-full rounded-2xl !p-0 !m-0 overflow-hidden">
          <ProgramCard program={program} key={program.name} enrolled={false} />
        </div>
      ))}
    </div>
  )

  return (
    <MultiProgramOnboardingFlowProvider>
      <NavigationPage
        title={title}
        subtitle={subtitle}
        id="onboarding-program-finder-page"
        navigationOptions={['close']}
        onCloseClick={onClosePage}
      >
        <NavigationPage.SingleCardContent>
          <LoadingContainer
            isLoading={isLoading}
            loadedContent={loadedContent}
          />
          {availablePrograms?.length === 0 && !isLoading && (
            <ButtonContainer>
              <Button
                className="mt-4"
                id="apply-btn"
                variant="primary"
                onClick={onButtonClicked}
              >
                Continue
              </Button>
            </ButtonContainer>
          )}
        </NavigationPage.SingleCardContent>
      </NavigationPage>
    </MultiProgramOnboardingFlowProvider>
  )
}
